// import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { AppState } from '../../store';
// import { INode } from '../../store/chatmessage/types';

function useChatData() {
  const chatBaseData = useSelector((state: AppState) => state.chatBaseData);

  const rootNode = chatBaseData.find(item => item.isRoot === true);
  if (rootNode === undefined) {
    throw Error('データ取得に失敗しました');
  }
  return { rootNode };
}

export { useChatData };
